import Text from "./Text";
import {useState} from "react";

const TRUNCATE = {whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', width: '100%'};

const COLUMNS = [{key: 'material', width: 447}, {key: 'partes', width: 152}, {key: 'cliente', width: 152}, {key: 'cantidad', width: 156, right: true}, {key: 'unidad', width: 101, right: true}];

const RecordMaterialsRow = props => {
    // console.log(props.data)
    const [hover, setHover] = useState(false);
    const [selected, setSelected] = useState(false);

    const isDark = props.theme.White !== "#FFFFFF";
    const rowColor = isDark ? props.theme.Ey : props.theme.Ed;
    const hoverColor = isDark ? props.theme.FOURFOUR : props.theme.Ey;
    const rowStyle = {display: 'flex', justifyContent: 'space-between', width: '100%', height: '38px', alignItems: 'center', boxSizing: 'border-box', border: `0.5px solid ${props.theme.Ey}`, borderRadius: '4px'};
    const textColor = hover ? props.theme.ONED : props.theme.SEVENB;

    const isSelectable = props.data.partes === 'Varios' && props.data.detalles && props.data.detalles.length > 0;

    const handleClick = () => {
        if(isSelectable) {
            setSelected(!selected);
        }
    }

    if(!props.selectedMonths || props.selectedMonths.length === 0) {    //Don't show anything if there are no months selected
        return null;
    }

    const formattedQty = (quantity) => {
        return parseFloat(quantity).toLocaleString('es-MX', {minimumFractionDigits: 3, maximumFractionDigits: 3});
    } 

    const renderCells = (values, color) => COLUMNS.map(col => (
        <div key={col.key} style={{display: 'flex', alignItems: 'center', justifyContent: col.right ? 'flex-end' : 'flex-start', boxSizing: 'border-box', padding: '0 16px', width: col.width, flex: 'none'}} title={values[col.key]}>
            <Text size={15} color={color} style={{...TRUNCATE, textAlign: col.right ? 'right' : 'left'}}>{values[col.key]}</Text>
        </div>
    ));

    return (
        <>
            <div onClick={handleClick} onMouseEnter={() => {setHover(true);}}  onMouseLeave={() => {setHover(false);}} style={{...rowStyle, backgroundColor: hover ? hoverColor : rowColor, cursor: isSelectable ? 'pointer' : 'default'}}>
                {renderCells({material: props.data.material, partes: props.data.partes, cliente: props.data.cliente, cantidad: formattedQty(props.data.cantidad), unidad: props.data.unidad}, selected ? props.theme.Magenta : textColor)}
            </div>
            {/* Breakdown */}
            {selected && isSelectable && props.data.detalles.length > 0 && (
                <div style={{width: '100%'}}>
                    {props.data.detalles.filter(detalle => props.selectedMonths.includes(detalle.mes)).map((item) => (     //Filter the results according to the selected months
                        <div key={`${item.material}-${item.noParte}-${item.cliente}-${item.mes}`} style={{...rowStyle, backgroundColor: 'rgba(230, 1, 126, .07)'}}>
                            {renderCells({material: item.material, partes: item.noParte, cliente: item.cliente, cantidad: formattedQty(item.cantidad), unidad: item.unidad}, props.theme.ONED)}
                        </div>
                    ))}
                </div>
            )}
        </>
    );
};
export default RecordMaterialsRow;